import React from 'react';
import AccessState from './AccessState';

const Unauthorized = () => {
  return <AccessState title="Unauthorized" message="You do not have permission to access this area." actionLabel="Go To Home" actionTo="/" />;
};

export default Unauthorized;
